import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { refreshVerificationStatus } from '../store/actions/verification';

export function ImportLoading({
  importStatus,
  refreshVerificationStatus,
  successMessages
}) {
  const [timer, setTimer] = useState(
    setInterval(() => refreshVerificationStatus(importStatus, successMessages), 3000)
  );

  useEffect(() => {
    return () => {
      clearInterval(timer);
      setTimer(null);
    };
  }, []);

  return null;
}

ImportLoading.propTypes = {
  importStatus: PropTypes.array.isRequired,
  refreshVerificationStatus: PropTypes.func.isRequired,
  successMessages: PropTypes.object.isRequired
};

const mapDispatchToProps = {
  refreshVerificationStatus
};

export default connect(null, mapDispatchToProps)(ImportLoading);
